export const getSudOuestData = () => ({
  name: "Sud-Ouest",
  country: "France",
  description: "Le Sud-Ouest est une région viticole diverse et traditionnelle, s'étendant de Bordeaux aux Pyrénées. Cette région produit une grande variété de vins, des vins rouges structurés aux vins blancs secs et moelleux, en passant par des vins doux naturels uniques.",
  type: "region",
  mapAreas: [
    { region: "Sud-Ouest", x: 35, y: 75, color: "#4B164C", size: 6 }
  ],
  statistics: {
    totalArea: "45,000 ha",
    production: "2.5 million hectolitres",
    appellations: "18 appellations",
    departments: "8 départements",
    exportPercentage: "15%"
  },
  characteristics: {
    climate: "Climat océanique tempéré avec influence méditerranéenne au sud",
    soil: "Sols très variés : argile, calcaire, sable, galets roulés",
    viticulture: "Viticulture traditionnelle, cépages autochtones, vins de terroir"
  },
  wineStyles: {
    red: "Vins rouges structurés et tanniques, du fruité au complexe",
    white: "Vins blancs secs et moelleux, aromatiques et complexes",
    rose: "Rosés fruités et équilibrés, parfaits pour l'apéritif",
    sweet: "Vins doux naturels, concentrés et complexes"
  },
  history: "La viticulture dans le Sud-Ouest remonte à l'époque romaine. Au Moyen Âge, les monastères ont développé la viticulture. Le XIXe siècle a vu l'émergence des appellations. Aujourd'hui, la région est reconnue pour ses vins de qualité et ses cépages autochtones.",
  foodPairing: "Cuisine du Sud-Ouest, foie gras, confit de canard, fromages, charcuteries",
  subregions: {
    "bergerac": {
      name: "Bergerac",
      description: "Région de Bergerac produisant des vins rouges et blancs de qualité, avec une forte identité terroir.",
      characteristics: {
        climate: "Climat océanique tempéré",
        soil: "Sols de calcaire, argile et sable",
        viticulture: "Viticulture traditionnelle, rendements limités"
      },
      grapeVarieties: {
        red: ["Merlot", "Cabernet Sauvignon", "Cabernet Franc", "Malbec"],
        white: ["Sémillon", "Sauvignon Blanc", "Muscadelle"]
      },
      wineStyles: {
        "bergerac-rouge": "Vins rouges fruités et équilibrés",
        "bergerac-blanc": "Vins blancs secs et aromatiques",
        "monbazillac": "Vins blancs moelleux et complexes"
      },
      foodPairing: "Viandes blanches, poissons, fromages, cuisine du Sud-Ouest"
    },
    "cahors": {
      name: "Cahors",
      description: "Région de Cahors produisant des vins rouges puissants et tanniques, principalement à base de Malbec.",
      characteristics: {
        climate: "Climat océanique avec influence méditerranéenne",
        soil: "Sols de calcaire, argile et galets roulés",
        viticulture: "Viticulture traditionnelle, vendanges manuelles"
      },
      grapeVarieties: {
        red: ["Malbec", "Merlot", "Tannat"]
      },
      wineStyles: {
        "cahors-rouge": "Vins rouges puissants et tanniques",
        "cahors-vieillissement": "Vins de garde, complexes et structurés"
      },
      foodPairing: "Viandes rouges, gibier, fromages affinés, cuisine du Sud-Ouest"
    },
    "madiran": {
      name: "Madiran",
      description: "Région de Madiran produisant des vins rouges puissants et tanniques, principalement à base de Tannat.",
      characteristics: {
        climate: "Climat océanique tempéré",
        soil: "Sols d'argile et de calcaire",
        viticulture: "Viticulture traditionnelle, vendanges manuelles"
      },
      grapeVarieties: {
        red: ["Tannat", "Cabernet Franc", "Cabernet Sauvignon"]
      },
      wineStyles: {
        "madiran-rouge": "Vins rouges puissants et tanniques",
        "madiran-vieillissement": "Vins de garde, complexes et structurés"
      },
      foodPairing: "Viandes rouges, gibier, fromages affinés, cuisine du Sud-Ouest"
    },
    "jurancon": {
      name: "Jurançon",
      description: "Région de Jurançon produisant des vins blancs secs et moelleux de grande qualité, avec une forte identité montagneuse.",
      characteristics: {
        climate: "Climat océanique avec influence montagneuse",
        soil: "Sols d'argile et de calcaire",
        viticulture: "Viticulture traditionnelle, vendanges manuelles"
      },
      grapeVarieties: {
        white: ["Petit Manseng", "Gros Manseng", "Courbu"]
      },
      wineStyles: {
        "jurancon-sec": "Vins blancs secs et aromatiques",
        "jurancon-moelleux": "Vins blancs moelleux et complexes"
      },
      foodPairing: "Poissons, volailles, fromages, desserts, cuisine du Sud-Ouest"
    }
  }
}); 